<template>
  <div class="col-12 white-bg">
    <div class="card-top flex flex-wrap relative header-padding">
      <div class="col-2 sm-hide xs-hide">
        <img
          :src="commonAttributes.product_image"
          :alt="commonAttributes.product_name"
          :title="commonAttributes.product_name"
          width="64"
        >
      </div>
      <div class="flex sm-col-12 col-10 md-col-8 items-center">
        <span class="h3">{{ commonAttributes.product_type }} </span>
      </div>
      <div class="flex col-2 xs-hide items-center justify-end">
        <span v-if="!isGymlibPurchase" class="h3 right bold">
          <span v-if="totalCharged < totalPrice" class="crossed">{{ totalPrice }} €</span>
          {{ totalCharged > 0 ? `${totalCharged} €` : 'Offert' }}
        </span>
      </div>
    </div>
    <template v-if="!isStage && item.details.some(d => d.tda_info)">
      <div v-for="(detail, index) in item.details" :key="`tda_info_${index}`" class="px4 pb2 justify tda-info">
        <div v-if="detail && detail.tda_info" v-html="detail.tda_info"></div>
      </div>
    </template>
    <NewTDACartStageDetails v-if="isStage" :details="item.details" :common-attributes="commonAttributes" />
    <NewTDACartCommonDetails v-else :details="item.details" :common-attributes="commonAttributes" />
  </div>
</template>

<script>
import NewTDACartStageDetails from './NewTDACartStageDetails.vue';
import NewTDACartCommonDetails from './NewTDACartCommonDetails.vue';

import { computeCommonAttributes } from '@/utils/logics';

export default {
  components: {
    NewTDACartStageDetails,
    NewTDACartCommonDetails
  },
  props: {
    item: Object,
    value: [Number, String],
    total: [Number, String]
  },
  computed: {
    totalPrice () {
      return this.total;
    },
    totalCharged () {
      return this.value;
    },
    commonAttributes () {
      return computeCommonAttributes(this.item.details[0]);
    },
    isStage () {
      return this.commonAttributes.inscription && ['STAGE'].includes(this.commonAttributes.offer_type);
    },
    isGymlibPurchase () {
      // Check if any detail has a Gymlib code (partner tariff)
      return this.item.details.some(detail => detail.gymlibCode);
    }
  }
};
</script>

<style lang="scss" scoped>
  .header-padding {
    padding-top: 2rem;
    padding-bottom: 2rem;
    padding-left: 4rem;
    padding-right: 4rem;
  }
  @media (max-width: 40em) {
    .header-padding {
      padding-left: 2rem;
      padding-right: 2rem;
      padding-top: 1rem;
      padding-bottom: 1rem;
    }
  }

</style>
